import { divideAccuracy } from "@/lobby_common/utils/utils";
export default {
  name: "mode20",
  components: {  },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      divideAccuracy,
    };
  },
  computed: {
    lang() {
      return this.$store.getters.getLang;
    },
    userData() {
      return this.$store.getters.user || {};
    },
    userAccuracy() {
      return this.userData.accuracy;
    },
    userCoinSymbol() {
      return this.userData.coinSymbol;
    },
    getUnreceivedNoticeObj() {
      return this.$store.getters.getUnreceivedNotice || {};
    },
    amount() {
      return this.getUnreceivedNoticeObj.amount
    },
  },
  watch: {},
  async created() {
  },
  mounted() {
    // console.log(this.arrContent, 'arrContent')
  },
  beforeDestroy() {
    
  },
  methods: {
    toEmail() {
      this.$router.push({
        name: "hNoticeCenter",
      });
    },
  },
  activated() {
  },
};
